module.exports = __webpack_public_path__ + "static/media/password.cd091463.svg";